// src/data/servicesData.js
// Lightweight metadata used by the Services landing page, the Navbar dropdown,
// the home Services grid and the cross-navigation strip on every service page.

export const servicesData = [
  {
    slug: 'expertise',
    title: 'Expertise',
    subtitle: 'Évaluation Immobilière',
    iconKey: 'check-double',
    excerpt:
      "Acte d'analyse professionnelle structuré, destiné à produire une appréciation fondée de la valeur et des caractéristiques d'un actif, conduit en alignement avec les standards RICS et IVS.",
  },
  {
    slug: 'conseil',
    title: 'Conseil',
    subtitle: 'Conseil & Accompagnement',
    iconKey: 'handshake',
    excerpt:
      "Espace de lecture et de compréhension des situations immobilières, destiné à apporter de la clarté dans des contextes patrimoniaux, juridiques, fiscaux et économiques.",
  },
  {
    slug: 'etudes',
    title: 'Études',
    subtitle: 'Études Immobilières',
    iconKey: 'chart-pie',
    excerpt:
      "Structuration de référentiels et modélisation des projets : transformer données de marché, cadres réglementaires et hypothèses en supports d'aide à la décision.",
  },
  {
    slug: 'formation',
    title: 'Formation',
    subtitle: 'Partage du Savoir',
    iconKey: 'user-graduate',
    excerpt:
      "Au-delà des missions d'expertise, le cabinet s'inscrit dans une démarche de partage du savoir immobilier, en collaboration avec institutions et acteurs académiques.",
  },
];

export const findServiceBySlug = (slug) =>
  servicesData.find((s) => s.slug === slug);

export const otherServices = (currentSlug) =>
  servicesData.filter((s) => s.slug !== currentSlug);
